import { OpenInNewTabText } from 'owa-locstrings/lib/strings/openinnewtabtext.locstring.json';
import loc from 'owa-localize';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';

export function getOpenInNewTabContextMenuItem(
    url: string,
    onClickCallback?: () => void
): IContextualMenuItem {
    return {
        name: loc(OpenInNewTabText),
        key: 'OpenInNewTab',
        onClick: () => {
            window.open(url, '_blank');
            if (onClickCallback) {
                onClickCallback();
            }
        },
    };
}
